export const balanceReminderColumns = [
    {
        field: "timeSlot",
        headerName: "TimeSlot",
        width: 160,
    },
    {
        field: "demo",
        headerName: "Demo",
        width: 160
    },
    {
        field: "balancePaid",
        headerName: "Balance Paid",
        width: 160
    },
    {
        field: "totalFees",
        headerName: "Total Fees",
        width: 160
    },
    {
        field: "balance",
        headerName: "Balance",
        width: 160
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
    {
        field: "serviceName",
        headerName: "Gym Service",
        width: 160,
    },
    {
        field: "category",
        headerName: "Gym Category",
        width: 160,
    },
    {
        field: "userName",
        headerName: "User Name",
        width: 160,
    },
    {
        field: "email",
        headerName: "User Email",
        width: 160,
    },
    {
        field: "clientNumber",
        headerName: "User Contact No.",
        width: 160,
    },
  ];